export default __webpack_public_path__ + "static/media/agrandir-narrow-bold.fc90863a.ttf";